// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function FlagIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M4.345 5.25A1 1 0 0 0 4 6v21a1 1 0 1 0 2 0v-5.529c3.349-2.645 6.234-1.218 9.556.427 2.05 1.013 4.258 2.106 6.625 2.106 1.741 0 3.568-.594 5.478-2.25a1.001 1.001 0 0 0 .345-.75V6a1 1 0 0 0-1.659-.75c-3.5 3.029-6.465 1.561-9.901-.14-3.56-1.765-7.596-3.761-12.099.14ZM26 20.531c-3.349 2.645-6.234 1.218-9.556-.426-3.125-1.544-6.601-3.266-10.444-1.05V6.474c3.349-2.645 6.234-1.219 9.556.425C18.681 8.443 22.16 10.165 26 7.949V20.53Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
